import { Loading } from "@sede-x/shell-ds-react-framework";
const LoadingPanel = () => (
  <div className="loading-wrapper">
    <Loading />
  </div>
);
export default LoadingPanel;
